import React, { useState, useEffect, useRef, useMemo } from "react";
import Modal from "react-bootstrap/Modal";
import { pushNotification } from "utils/notifications";
import ThuocTinhGiamTruApi from "service/ThuocTinhGiamTruApi";
import StoreApi from "service/storeApi";
import CauHinhTaiSanApi from "service/CauHinhTaiSanApi";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import TableDanhSachTaiSanMua from "./TableDanhSachTaiSanMua";
import ChiTietCuaHangApi from "service/chiTietCuaHangApi";
import UploadMultiFile from "components/GenericComponent/UploadMultiFile";
import NhapHangApi from "service/QuanLyMuaBan/NhapHangApi";
import { ModalXacNhanItem } from "./ModalXacNhanItem";
import NumberFormat from "react-number-format";
import ReactDropdown from "react-dropdown";
import { formatDateV2, convertDate } from "utils/formatDate";

const ThemSuaNhapHang = ({ orderId, onClose }) => {
  const [ListCauHinhTaiSan, setListCauHinhTaiSan] = useState([]);
  const [ListKho, setListKho] = useState([]);
  const [nameCode, setNameCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const assetFormRef = useRef(null);
  const [NgayNhap, setNgayNhap] = useState(new Date());
  const [TenKhachHang, setTenKhachHang] = useState("");
  const [SoDienThoai, setSoDienThoai] = useState("");
  const [DiaChi, setDiaChi] = useState("");
  const [OrderNote, setOrderNote] = useState("");
  const [CauHinhTaiSanId, setCauHinhTaiSanId] = useState(0);
  const [TenTaiSan, setTenTaiSan] = useState("");
  const [KhoID, setKhoID] = useState(0);
  const [hinhThucThanhToan, setHinhThucThanhToan] = useState(0);
  const [SoTien, setSoTien] = useState(0);
  const [PhiKhac, setPhiKhac] = useState(0);
  const [TongTien, setTongTien] = useState(0);
  const [GhiChu, setGhiChu] = useState("");
  const [ListThuocTinhtaiSan, setListThuocTinhTaiSan] = useState([]);
  const [ListImage, setListImage] = useState([]);
  const [editingAssetId, setEditingAssetId] = useState(null);
  const [ListDanhSachTaiSanMua, setListDanhSachTaiSanMua] = useState([]);
  const [ListTaiSanIdXoa, setListTaiSanIdXoa] = useState([]);
  const [showConfirmXoaItem, setShowConfirmXoaItem] = useState(false);
  const [deletingAsset, setDeletingAsset] = useState(null);

  const loadInitialComboData = () => {
    const promises = [
      StoreApi.comboAll({ storeName: "", storeAddress: "" }),
      ThuocTinhGiamTruApi.danhsachcauhinhtaisan(),
      ChiTietCuaHangApi.chiTietCuaHangHienTai(),
    ];
    return Promise.all(promises).then(([resKho, resTS, resCode]) => {
      return {
        khoList: resKho.data || [],
        cauhinhList: resTS.data.List || [],
        code: resCode.data.Code || "",
      };
    });
  };

  const loadListThuocTinhTaiSanByCauHinhTaiSanId = (CauHinhTaiSanId) => {
    return CauHinhTaiSanApi.GetThuocTinhTaiSanByCauHinhTaiSanId({
      id: CauHinhTaiSanId,
    })
      .then((res) => {
        const list = (res.data || []).map((item) => ({
          ...item,
          GiaTri: "",
        }));
        setListThuocTinhTaiSan(list);
        return list;
      })
      .catch((err) => {
        console.error("Lỗi load danh sách thuộc tính:", err);
        pushNotification(
          "Có lỗi load danh sách thuộc tính!",
          "error",
          "TOP_CENTER",
          2000,
        );
        return [];
      });
  };

  useEffect(() => {
    const loadEditData = (id, cauhinhList, khoList) => {
      setLoading(true);
      NhapHangApi.getChiTietNhapHang(id)
        .then((res) => {
          const data = res.data;
          setNgayNhap(convertDate(data.NgayNhap));
          setTenKhachHang(data.TenKhachHang);
          setSoDienThoai(data.SoDienThoai);
          setDiaChi(data.DiaChi);
          setHinhThucThanhToan(data.HinhThucThanhToan);
          setOrderNote(data.OrderNote || "");
          const assets = (data.DanhSachTaiSan || []).map((ts) => {
            const imageList = (ts.AnhTaiSan || "").split(";").filter(Boolean);
            return {
              ...ts,
              localId: Date.now() + Math.random(),
              AnhTaiSan: ts.AnhTaiSan || "",
              ListImageLocal: imageList,
              ThuocTinhTaiSan: ts.ThuocTinhTaiSan || [],
              LoaiTaiSanTen:
                cauhinhList.find((c) => c.CauHinhTaiSanId == ts.LoaiTaiSan)
                  ?.TenHangHoa || "",
              KhoTen:
                khoList.find((k) => k.StoreId == ts.KhoID)?.StoreName || "",
            };
          });
          setListDanhSachTaiSanMua(assets);
        })
        .catch((err) => {
          console.error("Lỗi load chi tiết đơn hàng:", err);
          pushNotification("Không thể tải dữ liệu đơn hàng", "error");
          onClose(false);
        })
        .finally(() => {
          setLoading(false);
        });
    };

    setLoading(true);
    loadInitialComboData()
      .then(({ khoList, cauhinhList, code }) => {
        setListKho(khoList);
        if (khoList.length > 0) setKhoID(khoList[0].StoreId);
        setListCauHinhTaiSan(cauhinhList);
        setNameCode(code);
        if (cauhinhList.length > 0) {
          const firstId = cauhinhList[0].CauHinhTaiSanId;
          setCauHinhTaiSanId(firstId);
          loadListThuocTinhTaiSanByCauHinhTaiSanId(firstId).finally(() => {
            if (orderId <= 0) setLoading(false);
          });
        } else if (orderId <= 0) {
          setLoading(false);
        }
        if (orderId > 0) {
          loadEditData(orderId, cauhinhList, khoList);
        }
      })
      .catch((error) => {
        console.error("Lỗi load data ban đầu:", error);
        pushNotification("Không thể tải dữ liệu ban đầu", "error");
        onClose(false);
        setLoading(false);
      });
  }, []);

  const loaiTaiSanOptions = useMemo(() => {
    return ListCauHinhTaiSan.map((ts) => ({
      value: ts.CauHinhTaiSanId,
      label: ts.TenHangHoa,
    }));
  }, [ListCauHinhTaiSan]);

  const khoOptions = useMemo(() => {
    return ListKho.map((kho) => ({
      value: kho.StoreId,
      label: kho.StoreName,
    }));
  }, [ListKho]);

  const handleChangeCauHinhTaiSanId = (option) => {
    const cauhinhid = option.value;
    setCauHinhTaiSanId(cauhinhid);
    loadListThuocTinhTaiSanByCauHinhTaiSanId(cauhinhid);
  };

  const handleChangeKhoID = (option) => {
    setKhoID(option.value);
  };

  const handleChangeMoney = (sotien, phikhac) => {
    const tong = (sotien || 0) + (phikhac || 0);
    setTongTien(tong);
  };

  const handleChangeThuocTinhValue = (index, value) => {
    setListThuocTinhTaiSan((prev) => {
      const newList = [...prev];
      newList[index].GiaTri = value;
      return newList;
    });
  };

  const resetAssetForm = () => {
    setTenTaiSan("");
    setSoTien(0);
    setPhiKhac(0);
    setTongTien(0);
    setGhiChu("");
    setListImage([]);
    setEditingAssetId(null);
    setListThuocTinhTaiSan((prev) =>
      prev.map((item) => ({ ...item, GiaTri: "" })),
    );
  };

  const onSaveAsset = () => {
    if (!TenTaiSan) {
      pushNotification("Vui lòng nhập Tên tài sản", "error");
      return;
    }

    const selectedLoaiTS = ListCauHinhTaiSan.find(
      (ts) => ts.CauHinhTaiSanId == CauHinhTaiSanId,
    );
    const anhTaiSanString = ListImage.map((img) => {
      if (typeof img.url !== "undefined") {
        return img.url;
      } else {
        return img;
      }
    }).join(";");
    const assetData = {
      TaiSanId: editingAssetId
        ? ListDanhSachTaiSanMua.find((a) => a.localId === editingAssetId)
            ?.TaiSanId || 0
        : 0,
      localId: editingAssetId || Date.now() + Math.random(),
      TenTaiSan: TenTaiSan,
      LoaiTaiSan: parseInt(CauHinhTaiSanId),
      LoaiTaiSanTen: selectedLoaiTS?.TenHangHoa || "",
      TienTo: selectedLoaiTS?.MaHangHoa || "",
      KhoID: parseInt(KhoID),
      KhoTen: ListKho.find((k) => k.StoreId == KhoID)?.StoreName || "",
      SoTien: SoTien,
      PhiKhac: PhiKhac,
      GhiChu: GhiChu,
      ThuocTinhTaiSan: ListThuocTinhtaiSan.map((tt) => ({
        OptionName: tt.MaThuocTinh,
        OptionValue: tt.GiaTri,
      })),
      AnhTaiSan: anhTaiSanString,
      ListImageLocal: [...ListImage],
    };

    if (editingAssetId) {
      setListDanhSachTaiSanMua((prev) =>
        prev.map((item) =>
          item.localId === editingAssetId ? assetData : item,
        ),
      );
    } else {
      setListDanhSachTaiSanMua((prev) => [assetData, ...prev]);
    }

    resetAssetForm();
  };

  const handleEditItem = (asset) => {
    if (assetFormRef.current) {
      assetFormRef.current.scrollIntoView({ behavior: "smooth" });
    }
    setEditingAssetId(asset.localId);
    setCauHinhTaiSanId(asset.LoaiTaiSan);
    setTenTaiSan(asset.TenTaiSan);
    setKhoID(asset.KhoID);
    setSoTien(asset.SoTien);
    setPhiKhac(asset.PhiKhac);
    setTongTien(asset.SoTien + asset.PhiKhac);
    setGhiChu(asset.GhiChu);
    setListImage(asset.ListImageLocal || []);
    loadListThuocTinhTaiSanByCauHinhTaiSanId(asset.LoaiTaiSan)
      .then((list) => {
        const updatedThuocTinh = list.map((tt) => {
          const savedValue = asset.ThuocTinhTaiSan.find(
            (a) => a.OptionName === tt.MaThuocTinh,
          );
          return {
            ...tt,
            GiaTri: savedValue ? savedValue.OptionValue : "",
          };
        });
        setListThuocTinhTaiSan(updatedThuocTinh);
      })
      .catch((error) => {
        console.error("Lỗi khi điền thuộc tính tài sản:", error);
      });
  };

  const handleDeleteItem = (asset) => {
    setDeletingAsset(asset);
    setShowConfirmXoaItem(true);
  };

  const confirmDeleteAsset = () => {
    if (!deletingAsset) return;

    setListDanhSachTaiSanMua((prev) =>
      prev.filter((item) => item.localId !== deletingAsset.localId),
    );

    if (deletingAsset.TaiSanId > 0) {
      setListTaiSanIdXoa((prev) => [...prev, deletingAsset.TaiSanId]);
    }

    setShowConfirmXoaItem(false);
    setDeletingAsset(null);
  };

  const handleSaveOrder = () => {
    if (!TenKhachHang) {
      pushNotification("Vui lòng nhập Tên khách hàng", "error");
      return;
    }
    if (ListDanhSachTaiSanMua.length === 0) {
      pushNotification(
        "Vui lòng thêm ít nhất một tài sản vào đơn hàng",
        "error",
      );
      return;
    }

    setSaving(true);

    const payload = {
      OrderID: orderId,
      NgayNhap: formatDateV2(NgayNhap),
      TenKhachHang: TenKhachHang,
      SoDienThoai: SoDienThoai,
      DiaChi: DiaChi,
      OrderNote: OrderNote,
      HinhThucThanhToan: hinhThucThanhToan,
      DanhSachTaiSan: ListDanhSachTaiSanMua.map((ts) => ({
        TaiSanId: ts.TaiSanId,
        TenTaiSan: ts.TenTaiSan,
        LoaiTaiSan: ts.LoaiTaiSan,
        KhoID: ts.KhoID,
        SoTien: ts.SoTien,
        PhiKhac: ts.PhiKhac,
        GhiChu: ts.GhiChu,
        AnhTaiSan: ts.AnhTaiSan,
        TienTo: ts.TienTo,
        ThuocTinhTaiSan: ts.ThuocTinhTaiSan,
      })),
      TaiSanIdsToDelete: ListTaiSanIdXoa,
    };

    console.log("payload", payload);
    NhapHangApi.themSuaNhapHang(payload)
      .then((res) => {
        if (res.status === 200) {
          pushNotification(
            res.data.Message || "Lưu đơn hàng thành công",
            "success",
          );
          onClose(true);
        } else {
          pushNotification(res.message || "Lưu thất bại", "error");
        }
      })
      .catch((err) => {
        console.error("Lỗi lưu đơn hàng:", err);
        const errMsg =
          err.response?.data?.Message ||
          err.response?.data ||
          err.message ||
          "Lỗi máy chủ";
        pushNotification(errMsg, "error");
      })
      .finally(() => {
        setSaving(false);
      });
  };

  return (
    <>
      <Modal
        show={true}
        size="new-size"
        centered
        className="modal-new modal fade text-left popup-detail"
        animation={true}
        style={{ zIndex: 1050 }}
      >
        {!showConfirmXoaItem && (
          <>
            <Modal.Header>
              <h4 className="modal-title">
                <span className="btn-icon-right">
                  <img
                    src="/app-assets/images/logo-quan-ly-mua-ban-nhap-hang-v2.png"
                    alt="logo"
                  />
                </span>
                <span style={{ fontWeight: "bold" }}>
                  {orderId === 0
                    ? "Thêm mới đơn nhập hàng"
                    : "Sửa thông tin đơn nhập hàng"}
                </span>
              </h4>
              <button
                type="button"
                className="close-popup-new"
                onClick={() => onClose(false)}
              >
                <i className="mdi mdi-close"></i>
              </button>
            </Modal.Header>
            <Modal.Body>
              {loading && (
                <div className="loader loader-default is-active"></div>
              )}

              <h3
                className="lead collapsed"
                style={{
                  paddingBottom: "5px",
                  color: "#00B69B",
                  fontWeight: "bold",
                }}
              >
                Thông tin đơn hàng
              </h3>
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <label style={{ fontWeight: "bold" }}>Ngày nhập</label>
                    <DateTimePicker
                      id="Time"
                      value={NgayNhap}
                      onChange={setNgayNhap}
                      placeholder="Chọn ngày nhập"
                      name="Time"
                      className="form-control input-sm"
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label style={{ fontWeight: "bold" }}>
                      Tên khách hàng<span className="text-danger">(*)</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Nhập tên khách hàng"
                      value={TenKhachHang}
                      onChange={(e) => setTenKhachHang(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label style={{ fontWeight: "bold" }}>Số điện thoại</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Nhập số điện thoại"
                      value={SoDienThoai}
                      onChange={(e) => setSoDienThoai(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label style={{ fontWeight: "bold" }}>Địa chỉ </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Nhập địa chỉ"
                      value={DiaChi}
                      onChange={(e) => setDiaChi(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group">
                    <label style={{ fontWeight: "bold" }}>
                      Ghi chú đơn hàng
                    </label>
                    <textarea
                      className="form-control1 input-sm"
                      placeholder="Ghi chú chung cho cả đơn hàng"
                      value={OrderNote}
                      onChange={(e) => setOrderNote(e.target.value)}
                      rows={2}
                      style={{ width: "100%" }}
                    ></textarea>
                  </div>
                </div>
              </div>

              <div ref={assetFormRef}>
                <h3
                  className="lead collapsed"
                  style={{
                    paddingBottom: "5px",
                    color: "#00B69B",
                    fontWeight: "bold",
                  }}
                >
                  Tài sản mua
                </h3>

                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label style={{ fontWeight: "bold" }}>
                        Loại tài sản<span className="text-danger">(*)</span>
                      </label>
                      <ReactDropdown
                        options={loaiTaiSanOptions}
                        onChange={handleChangeCauHinhTaiSanId}
                        value={loaiTaiSanOptions.find(
                          (opt) => opt.value === CauHinhTaiSanId,
                        )}
                        controlClassName="form-control input-sm"
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label style={{ fontWeight: "bold" }}>
                        Tên tài sản<span className="text-danger">(*)</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Nhập tên tài sản"
                        value={TenTaiSan}
                        onChange={(e) => setTenTaiSan(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label style={{ fontWeight: "bold" }}>Kho</label>
                      <ReactDropdown
                        options={khoOptions}
                        onChange={handleChangeKhoID}
                        value={khoOptions.find((opt) => opt.value === KhoID)}
                        controlClassName="form-control input-sm"
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label style={{ fontWeight: "bold" }}>Số tiền</label>
                      <NumberFormat
                        className="form-control"
                        placeholder="Nhập số tiền"
                        value={SoTien}
                        thousandSeparator=","
                        decimalSeparator="."
                        onValueChange={(values) => {
                          const { floatValue } = values;
                          setSoTien(floatValue || 0);
                          handleChangeMoney(floatValue || 0, PhiKhac);
                        }}
                        allowNegative={false}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label style={{ fontWeight: "bold" }}>Phí khác</label>
                      <NumberFormat
                        className="form-control"
                        placeholder="Nhập phí khác"
                        value={PhiKhac}
                        thousandSeparator=","
                        decimalSeparator="."
                        onValueChange={(values) => {
                          const { floatValue } = values;
                          setPhiKhac(floatValue || 0);
                          handleChangeMoney(SoTien, floatValue || 0);
                        }}
                        allowNegative={false}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label style={{ fontWeight: "bold" }}>Tổng tiền</label>
                      <NumberFormat
                        className="form-control"
                        placeholder="Tổng tiền"
                        value={TongTien}
                        thousandSeparator=","
                        decimalSeparator="."
                        disabled
                      />
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="form-group">
                      <label style={{ fontWeight: "bold" }}>
                        Ghi chú (cho tài sản này)
                      </label>
                      <textarea
                        id="Note"
                        className="form-control1 input-sm"
                        placeholder="Nhập nội dung ghi chú cho tài sản"
                        value={GhiChu}
                        onChange={(e) => setGhiChu(e.target.value)}
                        rows={2}
                        style={{ width: "100%" }}
                      ></textarea>
                    </div>
                  </div>
                </div>

                <h3
                  className="lead collapsed"
                  style={{
                    paddingBottom: "5px",
                    color: "#00B69B",
                    fontWeight: "bold",
                  }}
                >
                  Thông tin tài sản
                </h3>
                <div className="row">
                  {ListThuocTinhtaiSan &&
                    ListThuocTinhtaiSan.map((item, index) => (
                      <div className="col-md-3" key={item.MaThuocTinh}>
                        <TextInputOnRow
                          labelClass="label-control text-bold"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group"
                          labelText={item.ValueThuocTinh}
                          inputProps={{
                            name:
                              "ListThuocTinhTaiSan[" +
                              index +
                              "].ValueThuocTinh",
                            value: item.GiaTri,
                            onChange: (e) =>
                              handleChangeThuocTinhValue(index, e.target.value),
                          }}
                        ></TextInputOnRow>
                      </div>
                    ))}
                  <div className="col-md-12">
                    <div className="form-group">
                      <UploadMultiFile
                        Files={ListImage}
                        onChange={setListImage}
                        Code={nameCode}
                      />
                    </div>
                  </div>
                </div>

                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <button
                    className="btn"
                    onClick={onSaveAsset}
                    disabled={saving}
                    style={{
                      background: "#056569",
                      color: "white",
                      borderRadius: "6px",
                      fontSize: "13px",
                      fontWeight: "bold",
                      textTransform: "none",
                    }}
                  >
                    {editingAssetId ? (
                      <>
                        <i className="mdi mdi-check"></i>&nbsp; Cập nhật tài sản
                      </>
                    ) : (
                      <>
                        <img src="/app-assets/images/icon-add-v2.png" />
                        &nbsp; Thêm vào danh sách
                      </>
                    )}
                  </button>
                </div>
              </div>

              <h3
                className="lead collapsed"
                style={{
                  paddingBottom: "5px",
                  color: "#00B69B",
                  fontWeight: "bold",
                }}
              >
                Danh sách tài sản mua
              </h3>
              <TableDanhSachTaiSanMua
                list={ListDanhSachTaiSanMua}
                onEditItem={handleEditItem}
                onDeleteItem={handleDeleteItem}
              />
              <div className="row" style={{ float: "right" }}>
                <div className="col-md-12">
                  <div className="form-group">
                    <label style={{ fontWeight: "bold" }}>
                      Hình thức thanh toán
                    </label>
                    <select
                      name="BeforeAfter"
                      className="form-control input-sm select-v2"
                      onChange={(e) => setHinhThucThanhToan(e.target.value)}
                      value={hinhThucThanhToan}
                    >
                      <option value="0">Tiền mặt</option>
                      <option value="1">Chuyển khoản</option>
                    </select>
                  </div>
                </div>
              </div>
            </Modal.Body>

            <Modal.Footer>
              <button
                className="btn btn-new-main btn-closenew"
                onClick={() => onClose(false)}
                disabled={saving}
              >
                <i className="mdi mdi-close"></i>&nbsp; Đóng
              </button>
              <button
                className="btn btn-checknew"
                disabled={
                  saving || loading || ListDanhSachTaiSanMua.length === 0
                }
                style={{
                  background: "#056569",
                  color: "white",
                  borderRadius: "6px",
                  fontSize: "15px",
                  textTransform: "none",
                }}
                onClick={handleSaveOrder}
              >
                {saving ? (
                  <>
                    <span className="spinner-border spinner-border-sm"></span>
                    &nbsp; Đang lưu...
                  </>
                ) : (
                  <>
                    <img src="/app-assets/images/icon-add-v2.png" />
                    &nbsp; {orderId === 0 ? "Tạo đơn" : "Cập nhật đơn"}
                  </>
                )}
              </button>
            </Modal.Footer>
          </>
        )}
        {showConfirmXoaItem && (
          <ModalXacNhanItem
            show={showConfirmXoaItem}
            onHide={() => {
              setShowConfirmXoaItem(false);
              setDeletingAsset(null);
            }}
            onConfirm={confirmDeleteAsset}
            title="Xác nhận xóa tài sản"
            message={`Bạn có chắc chắn muốn xóa tài sản "${deletingAsset?.TenTaiSan}" khỏi đơn hàng?`}
          />
        )}
      </Modal>
    </>
  );
};

export default ThemSuaNhapHang;
